import React, { useState } from "react";
import { SendSharp } from "@mui/icons-material";
import { Send } from "lucide-react";
import { Button } from "@mui/material";

const ChatInput = ({ onSendMessage, disabled = false }) => {
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage("");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        gap: "8px",
        padding: "16px",
        borderTop: "1px solid #E5E7EB",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E5E7EB",
      }}
    >
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type your message..."
        disabled={disabled}
        style={{
          flex: 1,
          padding: "8px 12px",
          borderRadius: "8px",
          border: "1px solid #E5E7EB",
          backgroundColor: disabled ? "#F3F4F6" : "#FFFFFF",
          color: "#374151",
          fontSize: "1rem",
          transition: "border-color 0.2s, box-shadow 0.2s",
          "&:focus": {
            outline: "none",
            boxShadow: "0 0 0 2px #1f95b9",
            borderColor: "#3B82F6",
          },
        }}
      />
      <Button
        type="submit"
        disabled={!message.trim() || disabled}
        style={{
          cursor: "pointer",
          padding: "8px 12px",
          backgroundColor: "#24b8e7",
          color: "#FFFFFF",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#2563EB",
            cursor: "pointer",
          },
          "&:focus": {
            outline: "none",
            boxShadow: "0 0 0 2px #1f95b9",
            borderColor: "#3B82F6",
          },
          "&:disabled": {
            backgroundColor: "#D1D5DB",
            cursor: "not-allowed",
          },
          transition: "background-color 0.2s, box-shadow 0.2s",
        }}
      >
        <Send
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      </Button>
    </form>
  );
};

export default ChatInput;
